import React from "react";

const FlipVertical = ({ color }) => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="24"
    //   height="24"
    //   viewBox="0 0 24 24"
    //   fill="none"
    // >
    //   <path
    //     d="M16 17.01V10H14V17.01H11L15 21L19 17.01H16ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
    //     fill={color}
    //   />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M12.5714 14.01V7H10.2857V14.01H6.85714L11.4286 18L16 14.01H12.5714ZM4.57143 0L0 3.99H3.42857V11H5.71429V3.99H9.14286L4.57143 0ZM12.5714 14.01V7H10.2857V14.01H6.85714L11.4286 18L16 14.01H12.5714ZM4.57143 0L0 3.99H3.42857V11H5.71429V3.99H9.14286L4.57143 0Z"
        fill={color}
      />
    </svg>
  );
};

export default FlipVertical;
